import { Box, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  categorySelector,
  getCategoriesThunk,
} from "store/reducers/product/categorySlice";
import {
  getProductsThunk,
  productSelector,
} from "store/reducers/product/productSlice";
import {
  getSubCategoriesThunk,
  subCategorySelector,
} from "store/reducers/product/subCategorySlice";

const ProductPanel = ({ filter, setFilter }) => {
  const dispatch = useDispatch();
  // const [category, setCategory] = useState(null);
  // const [subCategory, setSubCategory] = useState(null);
  // const [product, setProduct] = useState(null);

  const categories = useSelector(categorySelector.selectAll);
  const subCategories = useSelector(subCategorySelector.selectAll).filter(
    (item) => item.category === filter.category?.id
  );

  const products = useSelector(productSelector.selectAll).filter(
    (item) =>
      item.category === filter.category?.id &&
      item.sub_category === filter.sub_category?.id
  );

  useEffect(() => {
    dispatch(getCategoriesThunk());
  }, []);

  useEffect(() => {
    if (filter.category) {
      // setSubCategory(null);
      dispatch(getSubCategoriesThunk(filter.category.id));
    }
  }, [filter.category]);

  useEffect(() => {
    if (filter.category) {
      dispatch(
        getProductsThunk({
          category: filter.category?.id ?? "",
          subCategory: filter.sub_category?.id ?? "",
          page_size:1000
        })
      );
    }
  }, [filter.category, filter.sub_category?.id]);

  // useEffect(() => {
  //   console.log(filter);
  // }, [filter]);
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <AutoCompleteList
          items={categories}
          name="name"
          label="Filter by categories"
          setValue={(value) => {
            setFilter({
              ...filter,
              category: value,
              sub_category: null,
              product: null,
            });
          }}
          value={filter.category}
        />
        <AutoCompleteList
          items={subCategories}
          name="name"
          label="Filter by subcategories"
          setValue={(value) => {
            setFilter({ ...filter, sub_category: value, product: null });
          }}
          value={filter.sub_category}
        />
        <AutoCompleteList
          items={products}
          name="name"
          label="Filter by product"
          setValue={(value) => {
            setFilter({ ...filter, product: value });
          }}
          value={filter.product}
        />
        <TextField
          label="Qty"
          value={filter.qty}
          onChange={(e) =>
            setFilter({ ...filter, qty: e.target.value })
          }
          type="number"
         
        />
        <Stack direction="row" justifyContent="center">
          <Typography>OR</Typography>
        </Stack>

        <TextField
          label="Min qty"
          value={filter.qty__gt}
          onChange={(e) =>
            setFilter({ ...filter, qty__gt: e.target.value })
          }
          type="number"
          
        />
        <TextField
          label="Max qty"
          value={filter.qty__lt}
          onChange={(e) =>
            setFilter({ ...filter, qty__lt: e.target.value })
          }
          type="number"
          
        />
      </Stack>
    </Box>
  );
};

export default ProductPanel;
